module.exports = __webpack_public_path__ + "static/media/completeOrder.70ee162c.png";